import React, { Component } from 'react';
import { Input, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';
import countries from '../../consts/Countries.json';

class PhoneInput extends Component {
    state = {
        code: '+972',
        phone: ''
    };

    constructor(props) {
        super(props);

        this.breakdownPhone = this.breakdownPhone.bind(this);
    }

    componentWillMount() {
        this.breakdownPhone(this.props.value);
    }

    componentWillUpdate(nextProps) {
        if (nextProps.value !== this.props.value && !nextProps.value) {
            this.setState({ code: '+972', phone: '' });
        }
    }

    breakdownPhone(phone) {
        const formattedPhone = phone ? phone.substring(this.state.code.length) : '';
        this.setState({ phone: formattedPhone });
    }

    handleChange = () => {
        const phone = this.state.code.replace('+', '').concat(this.state.phone);
        if (this.props.onChange) {
            this.props.onChange(phone);
        }
    }

    render() {
        const options = countries.map(({ phone }) => ({ key: phone, text: phone, value: phone }));

        return (
            <Input
                required={this.props.required || false}
                placeholder='Phone Number'
                type="phone"
                fluid
                value={this.state.phone}
                onChange={({ target }) => this.setState({ phone: target.value }, this.handleChange)}
                action={
                    <Dropdown
                        button
                        basic
                        floating
                        options={options}
                        value={this.state.code}
                        onChange={(e, { value }) => this.setState({ code: value }, this.handleChange)}
                    />
                }
            />
        );
    }
}

export { PhoneInput };